import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../i18n/i18n";
import { Bar } from "@visx/shape";
import { Group } from "@visx/group";
import { Text } from "@visx/text";
import AppHeader from "../components/AppHeader/AppHeader";
import ResponsiveWrapper from "../components/ResponsiveWrapper/ResponsiveWrapper";
import "../styles/notfound.css";

const MiniBarChart = ({ width, height }) => {
	const data = [4, 0, 4];
	const barWidth = 30;
	const gap = 30;
	const maxValue = Math.max(...data);
	const chartPaddingTop = 50;

	const safeHeight = Math.max(height, 160);
	const chartHeight = safeHeight - chartPaddingTop;

	const totalChartWidth = data.length * barWidth + (data.length - 1) * gap;
	const xOffset = (width - totalChartWidth) / 2;

	return (
		<svg width={width} height={safeHeight} className="bar-chart-svg">
			<Group top={chartPaddingTop} left={xOffset}>
				{data.map((value, index) => {
					const barHeight = (value / maxValue) * chartHeight;
					const x = index * (barWidth + gap);
					const y = chartHeight - barHeight;

					return (
						<React.Fragment key={index}>
							<Bar
								className="bar-chart-bar"
								x={x}
								y={y}
								width={barWidth}
								height={barHeight}
								rx={4}
							/>
							<Text
								className="bar-chart-label"
								x={x + barWidth / 2}
								y={y - 10}
								textAnchor="middle"
							>
								{value}
							</Text>
						</React.Fragment>
					);
				})}
			</Group>
		</svg>
	);
};

const NotFound = () => {
	const navigate = useNavigate();
	const { translate } = useTranslation();

	return (
		<div className="content not-found-404">
			<AppHeader />

			<ResponsiveWrapper fallbackHeight={200}>
				{({ width, height }) => (
					<div className="bar-chart-container">
						<MiniBarChart width={width} height={height} />
					</div>
				)}
			</ResponsiveWrapper>

			<h3 className="not-found-message">{translate("404.message")}</h3>

			<div className="back-button-wrapper">
				<button onClick={() => navigate("/")} className="primary-button">
					{translate("404.backHome", "Back to Home")}
				</button>
			</div>
		</div>
	);
};

export default NotFound;
